import React from 'react';
import styles from "./MobileNotSupportedLayout.module.scss";
import { NoMobileIllustration } from "./NoMobileIllustration";
import { NoMobileIllustrationForEmailVerification } from "./NoMobileIllustrationForEmailVerification";
const illustrationMap = {
  default: /*#__PURE__*/React.createElement(NoMobileIllustration, null),
  afterEmail: /*#__PURE__*/React.createElement(NoMobileIllustrationForEmailVerification, null)
};
export default function MobileNotSupportedLayout(props) {
  const {
    variant = 'default',
    content,
    testid
  } = props;
  return /*#__PURE__*/React.createElement("div", {
    className: styles.root,
    "data-testid": testid
  }, illustrationMap[variant], /*#__PURE__*/React.createElement("div", {
    className: styles.content
  }, content));
}